import * as Pages from '../pages'

export default new class Router {
    init() {
        this.currentPage = '';
        let {controller, action} = document.querySelector('body').dataset;
        
        controller = controller.toLocaleLowerCase();
        action = action.toLocaleLowerCase();

        if(Pages[controller] && Pages[controller][action]) {
            this.currentPage = Pages[controller]
            return this.currentPage[action]()
        }
    }
}